import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import ApproverSelect from './components/ApproverSelect'
// constants
import { Forms } from 'constants/forms'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'
// views
import { Wrapper } from './views'
// utils
import { getFieldsList } from 'utils/fields'
import { getReviewApproverFieldOptions } from 'utils/systemProcess'

interface Props {
  field: string
}

const selector = formValueSelector(Forms.SYSTEM_PROCESS_CREATE_FORM)

const SetReviewApprover: React.FC<Props> = ({ field }) => {
  const objectEntities = useSelector(objectEntitiesSelector)

  const object = useSelector((state) => selector(state, 'object'))

  return (
    <Wrapper>
      <ApproverSelect
        label={`Review Approvers`}
        name={`${field}.reviewApprovers`}
        fieldOptions={getReviewApproverFieldOptions(getFieldsList(objectEntities, object?.label))}
      />
    </Wrapper>
  )
}

export default SetReviewApprover
